var _style, _path, _path2, _polygon, _path3, _polygon2, _polygon3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon4, _defs, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _polyline17, _polyline18, _polyline19, _polyline20, _polyline21, _polyline22, _polyline23, _polyline24, _polyline25, _polyline26, _polyline27, _polyline28, _polyline29, _polyline30, _polyline31, _polyline32, _polyline33, _polyline34, _polyline35, _polyline36, _polyline37, _polyline38, _polyline39, _polyline40, _polyline41, _polyline42, _polyline43, _polyline44, _polyline45, _polyline46, _polyline47, _polyline48, _polyline49, _polyline50, _polyline51, _polyline52, _polyline53, _polyline54, _polyline55, _polyline56, _polyline57, _polyline58, _polyline59, _polyline60, _polyline61, _polyline62, _polyline63, _polyline64, _polyline65, _polyline66, _polyline67, _polyline68, _polyline69, _polyline70, _polyline71, _polyline72, _polyline73, _polyline74, _polyline75, _polyline76, _polyline77, _polyline78, _polyline79, _polyline80, _polyline81, _polyline82, _polyline83, _polyline84, _polyline85, _polyline86, _polyline87, _polyline88, _polyline89, _polyline90, _polyline91, _polyline92, _polyline93, _polyline94, _polyline95, _polyline96, _polyline97, _polyline98, _polyline99, _polyline100, _polyline101, _polyline102, _polyline103, _polyline104, _polyline105, _polyline106, _polyline107, _polyline108, _polyline109, _polyline110, _polyline111, _polyline112, _polyline113, _polyline114, _polyline115, _polyline116, _polyline117, _polyline118, _polyline119, _polyline120, _polyline121, _polyline122, _polyline123, _polyline124, _polyline125, _polyline126, _polyline127, _polyline128, _polyline129, _polyline130, _polyline131, _polyline132, _polyline133, _polyline134, _polyline135, _polyline136, _polyline137, _polyline138, _polyline139, _polyline140, _polyline141, _polyline142, _polyline143, _polyline144, _polyline145, _polyline146, _polyline147, _polyline148, _polyline149, _polyline150, _polyline151, _polyline152, _polyline153, _polyline154, _polyline155, _polyline156, _polyline157, _polyline158, _polyline159, _polyline160, _polyline161, _polyline162, _polyline163, _polyline164, _polyline165, _polyline166, _polyline167, _polyline168, _polyline169, _polyline170, _polyline171, _polyline172, _polyline173, _polyline174, _polyline175, _polyline176, _polyline177, _polyline178, _polyline179, _polyline180, _polyline181, _polyline182, _polyline183, _polyline184, _polyline185, _polyline186, _polyline187, _polyline188, _polyline189, _polyline190, _polyline191, _polyline192, _polyline193, _polyline194, _polyline195, _polyline196, _polyline197, _polyline198, _polyline199, _polyline200, _polyline201, _polyline202, _polyline203, _polyline204, _polyline205, _polyline206, _polyline207, _polyline208, _polyline209, _polyline210, _polyline211, _polyline212, _polyline213, _polyline214, _polyline215, _polyline216, _polyline217, _polyline218, _polyline219, _polyline220, _polyline221, _polyline222, _polyline223, _polyline224, _polyline225, _polyline226, _polyline227, _polyline228, _polyline229, _polyline230, _polyline231, _polyline232, _polyline233, _polyline234, _polyline235, _polyline236, _polyline237, _polyline238, _polyline239, _polyline240, _polyline241, _polyline242, _polyline243, _polyline244, _polyline245, _polyline246, _polyline247, _polyline248, _polyline249, _polyline250, _polyline251, _polyline252, _polyline253, _polyline254, _polyline255, _polyline256;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexuslinkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 47.4",
    style: {
      enableBackground: "new 0 0 260 47.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4D7090;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#4F657C;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#0593D3;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#E0E343;}\r\n\t.st4{clip-path:url(#SVGID_2_);fill:#005DA4;}\r\n\t.st5{clip-path:url(#SVGID_2_);fill:#005BA0;}\r\n\t.st6{clip-path:url(#SVGID_2_);fill:#00589A;}\r\n\t.st7{clip-path:url(#SVGID_2_);fill:#015595;}\r\n\t.st8{clip-path:url(#SVGID_2_);fill:#015290;}\r\n\t.st9{clip-path:url(#SVGID_2_);fill:#01508B;}\r\n\t.st10{clip-path:url(#SVGID_2_);fill:#024D86;}\r\n\t.st11{clip-path:url(#SVGID_2_);fill:#024A80;}\r\n\t.st12{clip-path:url(#SVGID_2_);fill:#02477B;}\r\n\t.st13{clip-path:url(#SVGID_2_);fill:#024576;}\r\n\t.st14{clip-path:url(#SVGID_2_);fill:#034271;}\r\n\t.st15{clip-path:url(#SVGID_2_);fill:#033F6C;}\r\n\t.st16{clip-path:url(#SVGID_2_);fill:#033C67;}\r\n\t.st17{clip-path:url(#SVGID_2_);fill:#033A61;}\r\n\t.st18{clip-path:url(#SVGID_2_);fill:#04375C;}\r\n\t.st19{clip-path:url(#SVGID_2_);fill:#043457;}\r\n\t.st20{clip-path:url(#SVGID_2_);fill:#043152;}\r\n\t.st21{clip-path:url(#SVGID_2_);fill:#042F4D;}\r\n\t.st22{clip-path:url(#SVGID_2_);fill:#052C47;}\r\n\t.st23{clip-path:url(#SVGID_2_);fill:#052942;}\r\n\t.st24{clip-path:url(#SVGID_2_);fill:#05273D;}\r\n\t.st25{clip-path:url(#SVGID_2_);fill:#052438;}\r\n\t.st26{clip-path:url(#SVGID_2_);fill:#062133;}\r\n\t.st27{clip-path:url(#SVGID_2_);fill:#061E2E;}\r\n\t.st28{clip-path:url(#SVGID_2_);fill:#061E2D;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.3,28.4c-2.8,6-5.6,12-8.4,18c-3.2-0.9-6-2.2-8.4-3.7l-0.3-1.3c2.2,1.2,5.6,2.9,8.4,3.7l7.2-15.5L25.3,28.4 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,28c0.1,4.5,2,8.4,5,11.9l25-21.3l2-4.2L31.7,13l-2.4,5L5.1,38.5C2.4,35.4,0.6,31.9,0.1,28L0.1,28z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "38.1,12 38.8,11.3 46.3,5 46.1,3.8 37.7,10.9  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,28.5l0.8,1.3c-6.4,12-19.6,18.6-33.1,17.5l-0.7-0.1L21,46l0,0l0.1,0C34.5,47.1,47.7,40.5,54.1,28.5 L54.1,28.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22.9,1.4 33.7,8.9 37.6,0.7 38.2,1.9 34.1,10.5 34.1,10.5 23.1,2.9  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.1,10.5 34.1,10.5 38.2,1.9 37.6,0.7 33.7,8.9  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.7,13l-0.2-0.1l-0.2-0.2l-0.1-0.1l-0.4-0.3l-0.2-0.2l-0.2-0.2L30.1,12l-0.2-0.2l-0.2-0.2l-0.2-0.2l-2-1.4 L27.2,10L27,9.8l-0.2-0.2l-0.2-0.1l-0.2-0.2l-0.2-0.2L25.9,9l-0.2-0.2l-0.2-0.2l-0.2-0.2L25,8.4l-0.2-0.2l-0.2-0.2l-0.2-0.2 l-0.2-0.1l-0.2-0.2l-0.2-0.2l-1.3-0.9l-0.2-0.2l-0.2-0.2l-0.2-0.1l-3.8-2.6l-0.2-0.2l-0.2-0.2l0,0l0,0C8.5,6.6,0.3,15.9,0,25.4 c-0.2,5,1.8,9.3,5.1,13.1L29.3,18L31.7,13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25,27.1c-2.8,6-5.6,12-8.4,18c-3.2-1-6-2.2-8.4-3.7C13.8,36.7,19.4,31.9,25,27.1L25,27.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.1,28.5C47.7,40.5,34.5,47.1,21,46L21,46l0.4-0.9l12-25.1l3.8-3.2L54.1,28.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.7,10.9c1.4-3,2.9-6,4.3-9c1.4,0.4,2.7,1.1,4.1,1.9C43.3,6.1,40.5,8.5,37.7,10.9L37.7,10.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.7,8.9c-3.6-2.5-7.1-5-10.7-7.5c4.3-1.6,9.6-1.9,14.7-0.8C36.3,3.4,35,6.2,33.7,8.9L33.7,8.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.1,28c0.1,4.5,2,8.4,5,11.9l25-21.3l2-4.2L31.7,13l-2.4,5L5.1,38.5C2.4,35.4,0.6,31.9,0.1,28L0.1,28z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,28c0.1,4.5,2,8.4,5,11.9v-1.4C2.4,35.4,0.6,31.9,0.1,28L0.1,28z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25.6,28.4 25,27.1 16.6,45.2 16.9,46.4  "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M65.8,18v14.8c0,1.1,0.3,2.5,0.9,4.2h-4.8c0.5-1.5,0.8-2.9,0.8-4.2V16.1c0-1.4-0.3-3-0.8-4.5H66l14.8,21.3 V16.1c0-1.5-0.3-3-0.9-4.5h4.9c-0.6,1.4-0.9,2.9-0.9,4.5v15.9c0,1.8,0.3,3.4,0.9,4.9h-5.5L65.8,18z M105.1,24.5 c0-2.1-1.3-3.1-4-3.1h-5c-0.9,0-1.6,0.1-2.2,0.2c-0.6,0.1-1,0.3-1.4,0.6c-0.3,0.3-0.6,0.7-0.7,1.2c-0.1,0.5-0.2,1.1-0.2,1.9v1.1 h13.5V24.5z M91.6,30.2c0,0.9,0.1,1.5,0.3,2.1c0.2,0.5,0.4,0.9,0.7,1.2c0.4,0.3,0.8,0.4,1.4,0.5c0.6,0.1,1.3,0.1,2.1,0.1h8.6 c1,0,2.1-0.4,3.1-1.3v4h-14c-1.5,0-2.6-0.1-3.4-0.2c-0.8-0.2-1.4-0.4-1.8-0.7c-0.4-0.3-0.7-0.8-0.8-1.5c-0.1-0.6-0.2-1.4-0.2-2.4 v-8.9c0-0.9,0.1-1.6,0.3-2.2c0.2-0.6,0.5-1.1,1-1.5c0.5-0.4,1.1-0.7,1.9-0.8c0.8-0.2,1.8-0.3,2.9-0.3h8.9c1.4,0,2.5,0.1,3.3,0.2 c0.8,0.1,1.4,0.4,1.9,0.7c0.4,0.4,0.7,0.8,0.8,1.5c0.1,0.6,0.2,1.4,0.2,2.4v5.9H91.6V30.2z M131.6,18.5c-0.7,0.5-1.3,1-1.8,1.4 c-0.5,0.5-1,1-1.4,1.5l-5.2,6.4l5.2,6.2c0.7,1,1.8,1.9,3.1,2.8h-6.2c-0.1-0.4-0.2-0.9-0.3-1.3c-0.1-0.4-0.3-0.8-0.6-1.2L121,30 l-3.1,4.3c-0.3,0.4-0.6,0.9-0.8,1.3c-0.2,0.4-0.3,0.9-0.3,1.4h-6.2c0.4-0.3,0.8-0.7,1.4-1.3c0.6-0.5,1.2-1.1,1.9-1.9l4.9-5.9 l-5.2-6.5c-0.4-0.4-0.8-0.9-1.3-1.4c-0.5-0.5-1.1-1-1.7-1.5h5.8v0.1c0,0.4,0.1,0.9,0.3,1.3c0.2,0.4,0.5,0.8,0.8,1.3L121,26 l3.3-4.5c0.9-1.1,1.4-2.1,1.4-2.8c0-0.1,0-0.1,0-0.2H131.6z M152.8,35c-0.2,0.7-0.6,1.2-1.4,1.5c-0.8,0.3-2,0.4-3.8,0.4h-6.6 c-1.4,0-2.5-0.1-3.3-0.2c-0.8-0.1-1.4-0.3-1.9-0.7c-0.4-0.3-0.7-0.8-0.8-1.4c-0.1-0.6-0.2-1.4-0.2-2.4V21.6 c0-1.1-0.3-2.1-0.8-3.1h5.6c-0.5,1.1-0.8,2.1-0.8,3.1v8.6c0,0.8,0.1,1.5,0.2,2c0.1,0.5,0.4,0.9,0.7,1.2c0.3,0.3,0.8,0.5,1.4,0.6 c0.6,0.1,1.3,0.2,2.2,0.2h5c0.8,0,1.6,0,2.1-0.1c0.6-0.1,1-0.3,1.4-0.5c0.3-0.3,0.6-0.7,0.7-1.2c0.2-0.5,0.2-1.2,0.2-2.1v-8.6 c0-1-0.3-2-0.9-3.1h5.7c-0.6,1-0.9,2.1-0.9,3.1v12.1c0,1.1,0.3,2.1,0.9,3.2h-4.8V35z M182.5,32.2c0,1-0.1,1.9-0.2,2.5 c-0.1,0.6-0.4,1.1-0.8,1.4c-0.4,0.3-1,0.5-1.8,0.7c-0.8,0.1-1.9,0.2-3.3,0.2h-14.8v-4.1c1.2,0.9,2.2,1.3,3.2,1.3h10.9 c1.2,0,2.1-0.2,2.7-0.7c0.7-0.5,1-1.1,1-1.8c0-0.7-0.3-1.3-1-1.7c-0.7-0.5-1.6-0.8-2.7-0.8h-9.3c-0.6,0-1.3-0.1-2-0.2 c-0.7-0.2-1.3-0.4-1.9-0.7c-0.6-0.3-1-0.7-1.4-1.2c-0.4-0.5-0.5-1.1-0.5-1.8v-2.1c0-1,0.1-1.8,0.2-2.5c0.1-0.6,0.4-1.1,0.8-1.4 c0.4-0.4,1-0.6,1.8-0.7c0.8-0.1,1.9-0.2,3.3-0.2h14.4v4.1c-1-0.9-2-1.3-3-1.3h-10.3c-0.4,0-0.8,0.1-1.2,0.2 c-0.4,0.1-0.8,0.3-1.1,0.5c-0.3,0.2-0.6,0.5-0.8,0.8s-0.3,0.7-0.3,1c0,0.8,0.3,1.5,1,1.9c0.7,0.5,1.5,0.7,2.4,0.7h9.8 c1.6,0,2.8,0.4,3.7,1.2c0.8,0.8,1.2,2,1.2,3.5V32.2z M185.2,37c0.6-1.4,0.9-2.7,0.9-3.8V15.5c0-1.3-0.3-2.6-0.9-3.9h5.8 c-0.6,1-0.9,2.3-0.9,3.9v18.6h8.1c0.9,0,1.9-0.4,3-1.3V37H185.2z M202.1,37c0.6-1.4,0.9-2.6,0.9-3.6V21.9c0-1.3-0.2-2.4-0.6-3.4 h5.5c-0.6,1.1-0.9,2.3-0.9,3.4v11.5c0,1.2,0.3,2.4,0.9,3.6H202.1z M207.5,13c0,0.5-0.2,1-0.7,1.4c-0.5,0.4-1,0.6-1.7,0.6 c-0.7,0-1.3-0.2-1.8-0.6c-0.5-0.4-0.7-0.8-0.7-1.4c0-0.5,0.2-1,0.7-1.3c0.4-0.4,1-0.6,1.8-0.6c0.7,0,1.3,0.2,1.7,0.6 C207.3,12.1,207.5,12.5,207.5,13L207.5,13z M228.3,37c0.6-1.1,0.9-2.2,0.9-3.4v-8.3c0-0.8-0.1-1.4-0.2-1.9 c-0.2-0.5-0.4-0.9-0.8-1.2c-0.4-0.3-0.8-0.5-1.4-0.6c-0.6-0.1-1.3-0.2-2.1-0.2h-5c-0.8,0-1.6,0.1-2.1,0.2c-0.6,0.2-1,0.4-1.4,0.7 c-0.4,0.3-0.6,0.8-0.7,1.4c-0.1,0.6-0.2,1.3-0.2,2.1v7.8c0,1.3,0.3,2.4,0.9,3.4h-5.8c0.6-1.3,0.9-2.4,0.9-3.4V21.8 c0-0.9-0.3-2-0.9-3.2h4.8l0.1,2.1c0.8-1.4,2.6-2.1,5.2-2.1h6.6c1.4,0,2.5,0.1,3.3,0.2c0.8,0.1,1.4,0.4,1.9,0.7 c0.4,0.3,0.7,0.8,0.8,1.4c0.1,0.6,0.2,1.4,0.2,2.4v10.2c0,1.2,0.3,2.3,0.8,3.4H228.3z M254.3,37c0.5-1.5,0.8-2.8,0.8-3.8 c0-0.9-0.1-1.6-0.3-2.1c-0.2-0.5-0.5-0.9-0.9-1.2c-0.4-0.3-0.9-0.4-1.4-0.5c-0.6-0.1-1.2-0.1-2-0.1h-9v3.4c0,1.3,0.3,2.8,0.9,4.4 h-5.8c0.6-1.7,0.9-3.2,0.9-4.4V13.8c0-1.2-0.3-2.4-0.9-3.3h5.8c-0.6,1-0.9,2.1-0.9,3.3l0.1,14.3l7.9-6.8c1.2-1,1.9-1.9,2.1-2.8 h6.2c-0.4,0.3-1,0.7-1.7,1.1c-0.7,0.4-1.5,1-2.4,1.6l-6.1,5.3h6.1c3.5,0,5.2,1.5,5.2,4.7v2c0,1.4,0.3,2.7,0.9,3.8H254.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "61.9,10.5 62.3,10.5 62.3,37 61.9,37  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "61.9,10.5 63.1,10.5 63.1,37 61.9,37  "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "62.7,10.5 63.9,10.5 63.9,37 62.7,37  "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "63.5,10.5 64.6,10.5 64.6,37 63.5,37  "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "64.2,10.5 65.4,10.5 65.4,37 64.2,37  "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "65,10.5 66.2,10.5 66.2,37 65,37  "
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "65.8,10.5 66.9,10.5 66.9,37 65.8,37  "
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "66.5,10.5 67.7,10.5 67.7,37 66.5,37  "
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "67.3,10.5 68.5,10.5 68.5,37 67.3,37  "
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "68.1,10.5 69.3,10.5 69.3,37 68.1,37  "
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "68.9,10.5 70,10.5 70,37 68.9,37  "
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "69.7,10.5 70.8,10.5 70.8,37 69.7,37  "
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "70.4,10.5 71.6,10.5 71.6,37 70.4,37  "
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "71.2,10.5 72.4,10.5 72.4,37 71.2,37  "
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "72,10.5 73.1,10.5 73.1,37 72,37  "
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "72.7,10.5 73.9,10.5 73.9,37 72.7,37  "
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "73.5,10.5 74.7,10.5 74.7,37 73.5,37  "
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "74.3,10.5 75.4,10.5 75.4,37 74.3,37  "
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "75.1,10.5 76.2,10.5 76.2,37 75.1,37  "
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "75.8,10.5 77,10.5 77,37 75.8,37  "
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "76.6,10.5 77.8,10.5 77.8,37 76.6,37  "
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "77.4,10.5 78.5,10.5 78.5,37 77.4,37  "
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "78.2,10.5 79.3,10.5 79.3,37 78.2,37  "
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "78.9,10.5 80.1,10.5 80.1,37 78.9,37  "
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "79.7,10.5 80.9,10.5 80.9,37 79.7,37  "
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "80.5,10.5 81.6,10.5 81.6,37 80.5,37  "
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "81.2,10.5 82.4,10.5 82.4,37 81.2,37  "
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "82,10.5 83.2,10.5 83.2,37 82,37  "
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "82.8,10.5 84,10.5 84,37 82.8,37  "
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "83.6,10.5 84.7,10.5 84.7,37 83.6,37  "
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "84.3,10.5 85.5,10.5 85.5,37 84.3,37  "
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "85.1,10.5 86.3,10.5 86.3,37 85.1,37  "
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "85.9,10.5 87,10.5 87,37 85.9,37  "
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "86.7,10.5 87.8,10.5 87.8,37 86.7,37  "
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "87.4,10.5 88.6,10.5 88.6,37 87.4,37  "
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "88.2,10.5 89.4,10.5 89.4,37 88.2,37  "
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "89,10.5 90.2,10.5 90.2,37 89,37  "
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "89.8,10.5 90.9,10.5 90.9,37 89.8,37  "
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "90.5,10.5 91.7,10.5 91.7,37 90.5,37  "
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "91.3,10.5 92.5,10.5 92.5,37 91.3,37  "
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "92.1,10.5 93.2,10.5 93.2,37 92.1,37  "
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "92.8,10.5 94,10.5 94,37 92.8,37  "
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "93.6,10.5 94.8,10.5 94.8,37 93.6,37  "
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "94.4,10.5 95.6,10.5 95.6,37 94.4,37  "
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "95.2,10.5 96.3,10.5 96.3,37 95.2,37  "
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "96,10.5 97.1,10.5 97.1,37 96,37  "
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "96.7,10.5 97.9,10.5 97.9,37 96.7,37  "
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "97.5,10.5 98.6,10.5 98.6,37 97.5,37  "
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "98.3,10.5 99.4,10.5 99.4,37 98.3,37  "
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "99,10.5 100.2,10.5 100.2,37 99,37  "
  })), _polyline51 || (_polyline51 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "99.8,10.5 101,10.5 101,37 99.8,37  "
  })), _polyline52 || (_polyline52 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "100.6,10.5 101.8,10.5 101.8,37 100.6,37  "
  })), _polyline53 || (_polyline53 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "101.4,10.5 102.5,10.5 102.5,37 101.4,37  "
  })), _polyline54 || (_polyline54 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "102.2,10.5 103.3,10.5 103.3,37 102.2,37  "
  })), _polyline55 || (_polyline55 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "102.9,10.5 104.1,10.5 104.1,37 102.9,37  "
  })), _polyline56 || (_polyline56 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "103.7,10.5 104.8,10.5 104.8,37 103.7,37  "
  })), _polyline57 || (_polyline57 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "104.5,10.5 105.6,10.5 105.6,37 104.5,37  "
  })), _polyline58 || (_polyline58 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "105.2,10.5 106.4,10.5 106.4,37 105.2,37  "
  })), _polyline59 || (_polyline59 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "106,10.5 107.2,10.5 107.2,37 106,37  "
  })), _polyline60 || (_polyline60 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "106.8,10.5 108,10.5 108,37 106.8,37  "
  })), _polyline61 || (_polyline61 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "107.6,10.5 108.7,10.5 108.7,37 107.6,37  "
  })), _polyline62 || (_polyline62 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "108.3,10.5 109.5,10.5 109.5,37 108.3,37  "
  })), _polyline63 || (_polyline63 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "109.1,10.5 110.3,10.5 110.3,37 109.1,37  "
  })), _polyline64 || (_polyline64 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "109.9,10.5 111,10.5 111,37 109.9,37  "
  })), _polyline65 || (_polyline65 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "110.6,10.5 111.8,10.5 111.8,37 110.6,37  "
  })), _polyline66 || (_polyline66 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "111.4,10.5 112.6,10.5 112.6,37 111.4,37  "
  })), _polyline67 || (_polyline67 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "112.2,10.5 113.4,10.5 113.4,37 112.2,37  "
  })), _polyline68 || (_polyline68 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "113,10.5 114.1,10.5 114.1,37 113,37  "
  })), _polyline69 || (_polyline69 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "113.8,10.5 114.9,10.5 114.9,37 113.8,37  "
  })), _polyline70 || (_polyline70 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "114.5,10.5 115.7,10.5 115.7,37 114.5,37  "
  })), _polyline71 || (_polyline71 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "115.3,10.5 116.5,10.5 116.5,37 115.3,37  "
  })), _polyline72 || (_polyline72 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "116.1,10.5 117.2,10.5 117.2,37 116.1,37  "
  })), _polyline73 || (_polyline73 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "116.8,10.5 118,10.5 118,37 116.8,37  "
  })), _polyline74 || (_polyline74 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "117.6,10.5 118.8,10.5 118.8,37 117.6,37  "
  })), _polyline75 || (_polyline75 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "118.4,10.5 119.6,10.5 119.6,37 118.4,37  "
  })), _polyline76 || (_polyline76 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "119.2,10.5 120.3,10.5 120.3,37 119.2,37  "
  })), _polyline77 || (_polyline77 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "119.9,10.5 121.1,10.5 121.1,37 119.9,37  "
  })), _polyline78 || (_polyline78 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "120.7,10.5 121.9,10.5 121.9,37 120.7,37  "
  })), _polyline79 || (_polyline79 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "121.5,10.5 122.6,10.5 122.6,37 121.5,37  "
  })), _polyline80 || (_polyline80 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "122.3,10.5 123.4,10.5 123.4,37 122.3,37  "
  })), _polyline81 || (_polyline81 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "123,10.5 124.2,10.5 124.2,37 123,37  "
  })), _polyline82 || (_polyline82 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "123.8,10.5 125,10.5 125,37 123.8,37  "
  })), _polyline83 || (_polyline83 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "124.6,10.5 125.7,10.5 125.7,37 124.6,37  "
  })), _polyline84 || (_polyline84 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "125.4,10.5 126.5,10.5 126.5,37 125.4,37  "
  })), _polyline85 || (_polyline85 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "126.1,10.5 127.3,10.5 127.3,37 126.1,37  "
  })), _polyline86 || (_polyline86 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "126.9,10.5 128.1,10.5 128.1,37 126.9,37  "
  })), _polyline87 || (_polyline87 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "127.7,10.5 128.8,10.5 128.8,37 127.7,37  "
  })), _polyline88 || (_polyline88 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "128.5,10.5 129.6,10.5 129.6,37 128.5,37  "
  })), _polyline89 || (_polyline89 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "129.2,10.5 130.4,10.5 130.4,37 129.2,37  "
  })), _polyline90 || (_polyline90 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "130,10.5 131.2,10.5 131.2,37 130,37  "
  })), _polyline91 || (_polyline91 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "130.8,10.5 131.9,10.5 131.9,37 130.8,37  "
  })), _polyline92 || (_polyline92 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "131.5,10.5 132.7,10.5 132.7,37 131.5,37  "
  })), _polyline93 || (_polyline93 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "132.3,10.5 133.5,10.5 133.5,37 132.3,37  "
  })), _polyline94 || (_polyline94 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "133.1,10.5 134.3,10.5 134.3,37 133.1,37  "
  })), _polyline95 || (_polyline95 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "133.9,10.5 135,10.5 135,37 133.9,37  "
  })), _polyline96 || (_polyline96 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "134.6,10.5 135.8,10.5 135.8,37 134.6,37  "
  })), _polyline97 || (_polyline97 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "135.4,10.5 136.6,10.5 136.6,37 135.4,37  "
  })), _polyline98 || (_polyline98 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "136.2,10.5 137.3,10.5 137.3,37 136.2,37  "
  })), _polyline99 || (_polyline99 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "136.9,10.5 138.1,10.5 138.1,37 136.9,37  "
  })), _polyline100 || (_polyline100 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "137.7,10.5 138.9,10.5 138.9,37 137.7,37  "
  })), _polyline101 || (_polyline101 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "138.5,10.5 139.7,10.5 139.7,37 138.5,37  "
  })), _polyline102 || (_polyline102 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "139.3,10.5 140.5,10.5 140.5,37 139.3,37  "
  })), _polyline103 || (_polyline103 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "140.1,10.5 141.2,10.5 141.2,37 140.1,37  "
  })), _polyline104 || (_polyline104 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "140.8,10.5 142,10.5 142,37 140.8,37  "
  })), _polyline105 || (_polyline105 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "141.6,10.5 142.8,10.5 142.8,37 141.6,37  "
  })), _polyline106 || (_polyline106 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "142.4,10.5 143.5,10.5 143.5,37 142.4,37  "
  })), _polyline107 || (_polyline107 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "143.1,10.5 144.3,10.5 144.3,37 143.1,37  "
  })), _polyline108 || (_polyline108 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "143.9,10.5 145.1,10.5 145.1,37 143.9,37  "
  })), _polyline109 || (_polyline109 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "144.7,10.5 145.9,10.5 145.9,37 144.7,37  "
  })), _polyline110 || (_polyline110 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "145.5,10.5 146.6,10.5 146.6,37 145.5,37  "
  })), _polyline111 || (_polyline111 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "146.3,10.5 147.4,10.5 147.4,37 146.3,37  "
  })), _polyline112 || (_polyline112 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "147,10.5 148.2,10.5 148.2,37 147,37  "
  })), _polyline113 || (_polyline113 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "147.8,10.5 148.9,10.5 148.9,37 147.8,37  "
  })), _polyline114 || (_polyline114 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "148.6,10.5 149.7,10.5 149.7,37 148.6,37  "
  })), _polyline115 || (_polyline115 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "149.3,10.5 150.5,10.5 150.5,37 149.3,37  "
  })), _polyline116 || (_polyline116 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "150.1,10.5 151.3,10.5 151.3,37 150.1,37  "
  })), _polyline117 || (_polyline117 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "150.9,10.5 152.1,10.5 152.1,37 150.9,37  "
  })), _polyline118 || (_polyline118 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "151.7,10.5 152.8,10.5 152.8,37 151.7,37  "
  })), _polyline119 || (_polyline119 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "152.4,10.5 153.6,10.5 153.6,37 152.4,37  "
  })), _polyline120 || (_polyline120 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "153.2,10.5 154.4,10.5 154.4,37 153.2,37  "
  })), _polyline121 || (_polyline121 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "154,10.5 155.1,10.5 155.1,37 154,37  "
  })), _polyline122 || (_polyline122 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "154.8,10.5 155.9,10.5 155.9,37 154.8,37  "
  })), _polyline123 || (_polyline123 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "155.5,10.5 156.7,10.5 156.7,37 155.5,37  "
  })), _polyline124 || (_polyline124 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "156.3,10.5 157.5,10.5 157.5,37 156.3,37  "
  })), _polyline125 || (_polyline125 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "157.1,10.5 158.2,10.5 158.2,37 157.1,37  "
  })), _polyline126 || (_polyline126 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "157.9,10.5 159,10.5 159,37 157.9,37  "
  })), _polyline127 || (_polyline127 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "158.6,10.5 159.8,10.5 159.8,37 158.6,37  "
  })), _polyline128 || (_polyline128 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "159.4,10.5 160.6,10.5 160.6,37 159.4,37  "
  })), _polyline129 || (_polyline129 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "160.2,10.5 161.3,10.5 161.3,37 160.2,37  "
  })), _polyline130 || (_polyline130 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "160.9,10.5 162.1,10.5 162.1,37 160.9,37  "
  })), _polyline131 || (_polyline131 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "161.7,10.5 162.9,10.5 162.9,37 161.7,37  "
  })), _polyline132 || (_polyline132 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "162.5,10.5 163.7,10.5 163.7,37 162.5,37  "
  })), _polyline133 || (_polyline133 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "163.3,10.5 164.4,10.5 164.4,37 163.3,37  "
  })), _polyline134 || (_polyline134 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "164,10.5 165.2,10.5 165.2,37 164,37  "
  })), _polyline135 || (_polyline135 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "164.8,10.5 166,10.5 166,37 164.8,37  "
  })), _polyline136 || (_polyline136 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "165.6,10.5 166.8,10.5 166.8,37 165.6,37  "
  })), _polyline137 || (_polyline137 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "166.4,10.5 167.5,10.5 167.5,37 166.4,37  "
  })), _polyline138 || (_polyline138 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "167.1,10.5 168.3,10.5 168.3,37 167.1,37  "
  })), _polyline139 || (_polyline139 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "167.9,10.5 169.1,10.5 169.1,37 167.9,37  "
  })), _polyline140 || (_polyline140 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "168.7,10.5 169.8,10.5 169.8,37 168.7,37  "
  })), _polyline141 || (_polyline141 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "169.5,10.5 170.6,10.5 170.6,37 169.5,37  "
  })), _polyline142 || (_polyline142 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "170.2,10.5 171.4,10.5 171.4,37 170.2,37  "
  })), _polyline143 || (_polyline143 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "171,10.5 172.2,10.5 172.2,37 171,37  "
  })), _polyline144 || (_polyline144 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "171.8,10.5 172.9,10.5 172.9,37 171.8,37  "
  })), _polyline145 || (_polyline145 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "172.6,10.5 173.7,10.5 173.7,37 172.6,37  "
  })), _polyline146 || (_polyline146 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "173.3,10.5 174.5,10.5 174.5,37 173.3,37  "
  })), _polyline147 || (_polyline147 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "174.1,10.5 175.3,10.5 175.3,37 174.1,37  "
  })), _polyline148 || (_polyline148 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "174.9,10.5 176,10.5 176,37 174.9,37  "
  })), _polyline149 || (_polyline149 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "175.6,10.5 176.8,10.5 176.8,37 175.6,37  "
  })), _polyline150 || (_polyline150 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "176.4,10.5 177.6,10.5 177.6,37 176.4,37  "
  })), _polyline151 || (_polyline151 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "177.2,10.5 178.4,10.5 178.4,37 177.2,37  "
  })), _polyline152 || (_polyline152 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "178,10.5 179.1,10.5 179.1,37 178,37  "
  })), _polyline153 || (_polyline153 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "178.7,10.5 179.9,10.5 179.9,37 178.7,37  "
  })), _polyline154 || (_polyline154 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "179.5,10.5 180.7,10.5 180.7,37 179.5,37  "
  })), _polyline155 || (_polyline155 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "180.3,10.5 181.4,10.5 181.4,37 180.3,37  "
  })), _polyline156 || (_polyline156 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "181.1,10.5 182.2,10.5 182.2,37 181.1,37  "
  })), _polyline157 || (_polyline157 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "181.8,10.5 183,10.5 183,37 181.8,37  "
  })), _polyline158 || (_polyline158 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "182.6,10.5 183.8,10.5 183.8,37 182.6,37  "
  })), _polyline159 || (_polyline159 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "183.4,10.5 184.6,10.5 184.6,37 183.4,37  "
  })), _polyline160 || (_polyline160 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "184.2,10.5 185.3,10.5 185.3,37 184.2,37  "
  })), _polyline161 || (_polyline161 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "184.9,10.5 186.1,10.5 186.1,37 184.9,37  "
  })), _polyline162 || (_polyline162 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "185.7,10.5 186.9,10.5 186.9,37 185.7,37  "
  })), _polyline163 || (_polyline163 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "186.5,10.5 187.6,10.5 187.6,37 186.5,37  "
  })), _polyline164 || (_polyline164 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "187.2,10.5 188.4,10.5 188.4,37 187.2,37  "
  })), _polyline165 || (_polyline165 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "188,10.5 189.2,10.5 189.2,37 188,37  "
  })), _polyline166 || (_polyline166 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "188.8,10.5 190,10.5 190,37 188.8,37  "
  })), _polyline167 || (_polyline167 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "189.6,10.5 190.7,10.5 190.7,37 189.6,37  "
  })), _polyline168 || (_polyline168 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "190.4,10.5 191.5,10.5 191.5,37 190.4,37  "
  })), _polyline169 || (_polyline169 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "191.1,10.5 192.3,10.5 192.3,37 191.1,37  "
  })), _polyline170 || (_polyline170 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "191.9,10.5 193,10.5 193,37 191.9,37  "
  })), _polyline171 || (_polyline171 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "192.7,10.5 193.8,10.5 193.8,37 192.7,37  "
  })), _polyline172 || (_polyline172 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "193.4,10.5 194.6,10.5 194.6,37 193.4,37  "
  })), _polyline173 || (_polyline173 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "194.2,10.5 195.4,10.5 195.4,37 194.2,37  "
  })), _polyline174 || (_polyline174 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "195,10.5 196.2,10.5 196.2,37 195,37  "
  })), _polyline175 || (_polyline175 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "195.8,10.5 196.9,10.5 196.9,37 195.8,37  "
  })), _polyline176 || (_polyline176 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "196.6,10.5 197.7,10.5 197.7,37 196.6,37  "
  })), _polyline177 || (_polyline177 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "197.3,10.5 198.5,10.5 198.5,37 197.3,37  "
  })), _polyline178 || (_polyline178 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "198.1,10.5 199.2,10.5 199.2,37 198.1,37  "
  })), _polyline179 || (_polyline179 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "198.9,10.5 200,10.5 200,37 198.9,37  "
  })), _polyline180 || (_polyline180 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "199.6,10.5 200.8,10.5 200.8,37 199.6,37  "
  })), _polyline181 || (_polyline181 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "200.4,10.5 201.6,10.5 201.6,37 200.4,37  "
  })), _polyline182 || (_polyline182 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "201.2,10.5 202.3,10.5 202.3,37 201.2,37  "
  })), _polyline183 || (_polyline183 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "202,10.5 203.1,10.5 203.1,37 202,37  "
  })), _polyline184 || (_polyline184 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "202.7,10.5 203.9,10.5 203.9,37 202.7,37  "
  })), _polyline185 || (_polyline185 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "203.5,10.5 204.7,10.5 204.7,37 203.5,37  "
  })), _polyline186 || (_polyline186 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "204.3,10.5 205.4,10.5 205.4,37 204.3,37  "
  })), _polyline187 || (_polyline187 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "205,10.5 206.2,10.5 206.2,37 205,37  "
  })), _polyline188 || (_polyline188 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "205.8,10.5 207,10.5 207,37 205.8,37  "
  })), _polyline189 || (_polyline189 = /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "206.6,10.5 207.8,10.5 207.8,37 206.6,37  "
  })), _polyline190 || (_polyline190 = /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "207.4,10.5 208.5,10.5 208.5,37 207.4,37  "
  })), _polyline191 || (_polyline191 = /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "208.1,10.5 209.3,10.5 209.3,37 208.1,37  "
  })), _polyline192 || (_polyline192 = /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "208.9,10.5 210.1,10.5 210.1,37 208.9,37  "
  })), _polyline193 || (_polyline193 = /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "209.7,10.5 210.9,10.5 210.9,37 209.7,37  "
  })), _polyline194 || (_polyline194 = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "210.5,10.5 211.6,10.5 211.6,37 210.5,37  "
  })), _polyline195 || (_polyline195 = /*#__PURE__*/React.createElement("polyline", {
    className: "st12",
    points: "211.2,10.5 212.4,10.5 212.4,37 211.2,37  "
  })), _polyline196 || (_polyline196 = /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "212,10.5 213.2,10.5 213.2,37 212,37  "
  })), _polyline197 || (_polyline197 = /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "212.8,10.5 213.9,10.5 213.9,37 212.8,37  "
  })), _polyline198 || (_polyline198 = /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "213.6,10.5 214.7,10.5 214.7,37 213.6,37  "
  })), _polyline199 || (_polyline199 = /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "214.3,10.5 215.5,10.5 215.5,37 214.3,37  "
  })), _polyline200 || (_polyline200 = /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "215.1,10.5 216.3,10.5 216.3,37 215.1,37  "
  })), _polyline201 || (_polyline201 = /*#__PURE__*/React.createElement("polyline", {
    className: "st18",
    points: "215.9,10.5 217,10.5 217,37 215.9,37  "
  })), _polyline202 || (_polyline202 = /*#__PURE__*/React.createElement("polyline", {
    className: "st19",
    points: "216.7,10.5 217.8,10.5 217.8,37 216.7,37  "
  })), _polyline203 || (_polyline203 = /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "217.4,10.5 218.6,10.5 218.6,37 217.4,37  "
  })), _polyline204 || (_polyline204 = /*#__PURE__*/React.createElement("polyline", {
    className: "st21",
    points: "218.2,10.5 219.4,10.5 219.4,37 218.2,37  "
  })), _polyline205 || (_polyline205 = /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "219,10.5 220.1,10.5 220.1,37 219,37  "
  })), _polyline206 || (_polyline206 = /*#__PURE__*/React.createElement("polyline", {
    className: "st23",
    points: "219.7,10.5 220.9,10.5 220.9,37 219.7,37  "
  })), _polyline207 || (_polyline207 = /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "220.5,10.5 221.7,10.5 221.7,37 220.5,37  "
  })), _polyline208 || (_polyline208 = /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "221.3,10.5 222.5,10.5 222.5,37 221.3,37  "
  })), _polyline209 || (_polyline209 = /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "222.1,10.5 223.2,10.5 223.2,37 222.1,37  "
  })), _polyline210 || (_polyline210 = /*#__PURE__*/React.createElement("polyline", {
    className: "st27",
    points: "222.9,10.5 224,10.5 224,37 222.9,37  "
  })), _polyline211 || (_polyline211 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "223.6,10.5 224.8,10.5 224.8,37 223.6,37  "
  })), _polyline212 || (_polyline212 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "224.4,10.5 225.5,10.5 225.5,37 224.4,37  "
  })), _polyline213 || (_polyline213 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "225.2,10.5 226.3,10.5 226.3,37 225.2,37  "
  })), _polyline214 || (_polyline214 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "225.9,10.5 227.1,10.5 227.1,37 225.9,37  "
  })), _polyline215 || (_polyline215 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "226.7,10.5 227.9,10.5 227.9,37 226.7,37  "
  })), _polyline216 || (_polyline216 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "227.5,10.5 228.7,10.5 228.7,37 227.5,37  "
  })), _polyline217 || (_polyline217 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "228.3,10.5 229.4,10.5 229.4,37 228.3,37  "
  })), _polyline218 || (_polyline218 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "229,10.5 230.2,10.5 230.2,37 229,37  "
  })), _polyline219 || (_polyline219 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "229.8,10.5 231,10.5 231,37 229.8,37  "
  })), _polyline220 || (_polyline220 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "230.6,10.5 231.7,10.5 231.7,37 230.6,37  "
  })), _polyline221 || (_polyline221 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "231.3,10.5 232.5,10.5 232.5,37 231.3,37  "
  })), _polyline222 || (_polyline222 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "232.1,10.5 233.3,10.5 233.3,37 232.1,37  "
  })), _polyline223 || (_polyline223 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "232.9,10.5 234.1,10.5 234.1,37 232.9,37  "
  })), _polyline224 || (_polyline224 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "233.7,10.5 234.9,10.5 234.9,37 233.7,37  "
  })), _polyline225 || (_polyline225 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "234.5,10.5 235.6,10.5 235.6,37 234.5,37  "
  })), _polyline226 || (_polyline226 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "235.2,10.5 236.4,10.5 236.4,37 235.2,37  "
  })), _polyline227 || (_polyline227 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "236,10.5 237.2,10.5 237.2,37 236,37  "
  })), _polyline228 || (_polyline228 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "236.8,10.5 237.9,10.5 237.9,37 236.8,37  "
  })), _polyline229 || (_polyline229 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "237.5,10.5 238.7,10.5 238.7,37 237.5,37  "
  })), _polyline230 || (_polyline230 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "238.3,10.5 239.5,10.5 239.5,37 238.3,37  "
  })), _polyline231 || (_polyline231 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "239.1,10.5 240.3,10.5 240.3,37 239.1,37  "
  })), _polyline232 || (_polyline232 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "239.9,10.5 241,10.5 241,37 239.9,37  "
  })), _polyline233 || (_polyline233 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "240.7,10.5 241.8,10.5 241.8,37 240.7,37  "
  })), _polyline234 || (_polyline234 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "241.4,10.5 242.6,10.5 242.6,37 241.4,37  "
  })), _polyline235 || (_polyline235 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "242.2,10.5 243.3,10.5 243.3,37 242.2,37  "
  })), _polyline236 || (_polyline236 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "243,10.5 244.1,10.5 244.1,37 243,37  "
  })), _polyline237 || (_polyline237 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "243.7,10.5 244.9,10.5 244.9,37 243.7,37  "
  })), _polyline238 || (_polyline238 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "244.5,10.5 245.7,10.5 245.7,37 244.5,37  "
  })), _polyline239 || (_polyline239 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "245.3,10.5 246.5,10.5 246.5,37 245.3,37  "
  })), _polyline240 || (_polyline240 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "246.1,10.5 247.2,10.5 247.2,37 246.1,37  "
  })), _polyline241 || (_polyline241 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "246.8,10.5 248,10.5 248,37 246.8,37  "
  })), _polyline242 || (_polyline242 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "247.6,10.5 248.8,10.5 248.8,37 247.6,37  "
  })), _polyline243 || (_polyline243 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "248.4,10.5 249.5,10.5 249.5,37 248.4,37  "
  })), _polyline244 || (_polyline244 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "249.2,10.5 250.3,10.5 250.3,37 249.2,37  "
  })), _polyline245 || (_polyline245 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "249.9,10.5 251.1,10.5 251.1,37 249.9,37  "
  })), _polyline246 || (_polyline246 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "250.7,10.5 251.9,10.5 251.9,37 250.7,37  "
  })), _polyline247 || (_polyline247 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "251.5,10.5 252.6,10.5 252.6,37 251.5,37  "
  })), _polyline248 || (_polyline248 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "252.3,10.5 253.4,10.5 253.4,37 252.3,37  "
  })), _polyline249 || (_polyline249 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "253,10.5 254.2,10.5 254.2,37 253,37  "
  })), _polyline250 || (_polyline250 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "253.8,10.5 255,10.5 255,37 253.8,37  "
  })), _polyline251 || (_polyline251 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "254.6,10.5 255.7,10.5 255.7,37 254.6,37  "
  })), _polyline252 || (_polyline252 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "255.3,10.5 256.5,10.5 256.5,37 255.3,37  "
  })), _polyline253 || (_polyline253 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "256.1,10.5 257.3,10.5 257.3,37 256.1,37  "
  })), _polyline254 || (_polyline254 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "256.9,10.5 258.1,10.5 258.1,37 256.9,37  "
  })), _polyline255 || (_polyline255 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "257.7,10.5 258.8,10.5 258.8,37 257.7,37  "
  })), _polyline256 || (_polyline256 = /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "258.4,10.5 260,10.5 260,37 258.4,37  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexuslinkLogo);
export default __webpack_public_path__ + "static/media/Nexuslink-Logo.d470858bcd6b9f6d991b1ce6b8735462.svg";
export { ForwardRef as ReactComponent };